<template>
    <div>
        <b-alert variant="primary" :show="show">
            <div class="alert-body">
                <span> Equipos Contrato </span>
            </div>
        </b-alert>
        <b-card no-body class="mb-0 mt-1" title="Equipo" :show="!show">
            <div class="m-2">
                <b-col md="12">
                    <div class="demo-inline-spacing">
                        <b-button
                            @click="search()"
                            variant="primary"
                            class="float-left"
                            v-if="!working"
                        >
                            <feather-icon icon="SearchIcon" />
                            <span class="align-middle">Consultar Equipos</span>
                        </b-button>
                        <b-button
                            v-else
                            variant="dark"
                            class="float-left"
                            disabled
                        >
                            <b-spinner small />
                            Procesando...
                        </b-button>
                    </div>
                </b-col>

                <!-- BUSQUEDA -->
                <div class="m-2" md="12">
                    <!-- Table Top -->
                    <b-row>
                        <!-- Per Page -->
                        <b-col
                            cols="12"
                            md="6"
                            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                        >
                            <label>Ver</label>
                            <v-select
                                v-model="perPage"
                                :dir="
                                    $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="perPageOptions"
                                :clearable="false"
                                class="per-page-selector d-inline-block mx-50"
                            />
                            <label>Lista</label>
                        </b-col>

                        <!-- Search -->
                        <b-col cols="12" md="6">
                            <div
                                class="d-flex align-items-center justify-content-end"
                            >
                                <b-form-input
                                    v-model="searchQuery"
                                    class="d-inline-block mr-1"
                                    placeholder="Buscar..."
                                />
                                <b-button
                                    variant="primary"
                                    @click="showModalOtNewEquipment"
                                >
                                    <span class="text-nowrap">
                                        <feather-icon icon="PlusIcon" />
                                        Solicitar Nuevo Equipo</span
                                    >
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <!-- FIN BUSQUEDA-->

                <!-- INICIO TABLE-->
                <div id="printEquipment">
                    <b-table
                        striped
                        hover
                        ref="refUserListTable"
                        class="position-relative"
                        :items="dataReport"
                        responsive
                        :fields="columns"
                        :sort-by.sync="sortBy"
                        show-empty
                        :filter="searchQuery"
                        empty-text="No existen registros para mostrar"
                        :sort-desc.sync="isSortDirDesc"
                        :per-page="perPage"
                        :current-page="currentPage"
                        id="my-table"
                        small
                    >
                        <!-- serial -->
                        <template #cell(serial)="data">
                            <b-media vertical-align="center">
                                <template #aside>
                                    <b-avatar
                                        size="30"
                                        :variant="`light-${data.item.equipo.tipoprodclass}`"
                                        :id="`equipo-${data.item.equipo.idcontratoequipo}`"
                                    >
                                        <feather-icon
                                            :icon="
                                                data.item.equipo.tipoprodicono
                                            "
                                        />
                                    </b-avatar>
                                </template>

                                <div
                                    class="font-weight-bold d-block text-nowrap"
                                >
                                    {{ data.item.equipo.serial }}
                                </div>
                            </b-media>
                        </template>
                        <!-- / serial -->

                        <!-- estado -->
                        <template #cell(estado)="data">
                            <b-badge pill :variant="data.item.equipo.class">
                                {{ data.item.equipo.estado }}
                            </b-badge>
                        </template>
                        <!-- / estado -->

                        <!-- equipo -->
                        <template #cell(equipo)="data">
                            <span
                                class="d-block text-nowrap"
                                v-if="
                                    data.item.equipo.equipo_olt != '' &&
                                    data.item.equipo.equipo_olt != null
                                "
                            >
                                {{ data.item.equipo.equipo_olt }}
                            </span>
                            <span
                                class="d-block text-nowrap"
                                v-if="
                                    data.item.equipo.equipo_cas != '' &&
                                    data.item.equipo.equipo_cas != null
                                "
                            >
                                {{ data.item.equipo.equipo_cas }}
                            </span>
                        </template>
                        <!-- / equipo -->

                        <!-- acciones -->
                        <template #cell(acciones)="">
                            <div class="text-nowrap"></div>
                        </template>
                        <!-- / acciones -->
                    </b-table>
                </div>
                <!-- / table -->

                <!-- paginate -->
                <b-col cols="12">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        hide-goto-end-buttons
                        :per-page="perPage"
                        align="center"
                        aria-controls="my-table"
                        size="md"
                        first-number
                        last-number
                        prev-class="prev-item"
                        next-class="next-item"
                    />
                </b-col>

                <modal-ot-new-equipment :idcontrato="idcontrato" />
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BAlert,
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCol,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BLink,
    BMedia,
    BModal,
    BPagination,
    BRow,
    BSpinner,
    BTable,
    BTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ModalOtNewEquipment from "./modal/ModalOtNewEquipment.vue";
import useList from "./useList";

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardBody,
        BButton,
        BCardText,
        BFormInput,
        BTable,
        BSpinner,
        BTooltip,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BLink,
        BAvatar,
        BMedia,
        BModal,
        BAlert,
        ModalOtNewEquipment,
        vSelect,
    },
    props: {
        idcontrato: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            working: false,
            userData: JSON.parse(localStorage.getItem("userData")),
            ot: {
                tipo: null,
            },
            contractEquipment: {},
            dataReport: [],
            columns: [
                { key: "serial", label: "serial", sortable: true },
                {
                    key: "equipo.fecha",
                    label: "Fecha",
                    sortable: true,
                    formatter: "dateFormat",
                },
                { key: "equipo.ubicacion", label: "ubicacion", sortable: true },
                {
                    key: "equipo.paquetes",
                    label: "paquete",
                    sortable: true,
                    formatter: "formatPlan",
                    sortByFormatted: true,
                },
                {
                    key: "estado",
                    label: "estado",
                    sortable: true,
                    formatter: "formatStatus",
                    sortByFormatted: true,
                },
            ],
            show: true,
            header: {},
        };
    },
    directives: {
        Ripple,
    },
    created() {
        if (this.data != null) {
            this.header = {
                codigo: this.data.codigo,
                apenom: this.data.apenom,
            };
        }
        if (typeof this.idcontrato != undefined) {
            this.show = false;
            this.search();
        }
    },
    methods: {
        newForm() {
            this.$router.go(0);
        },
        search() {
            this.working = true;
            this.$http
                .get("/contrato-equipo", {
                    params: {
                        idcontrato: this.idcontrato,
                    },
                })
                .then((response) => {
                    this.working = false;
                    this.dataReport = response.data.data;
                })
                .catch((error) => {
                    this.working = false;
                    console.log(error);
                    this.$swal({
                        title: "Error",
                        text: error.response.data.error,
                        icon: "error",
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                });
        },
        showModalOtNewEquipment() {
            this.$root.$emit("bv::show::modal", "modal-ot-new-equipment");
        },
        reload() {
            this.search();
        },
        formatPlan(value) {
            if (value.length > 0) {
                return `${value[0].nombre} - ${value[0].precio}`;
            }
        },
        dateFormat: function (string) {
            if (string == null) return "";
            return string.split("-").reverse().join("/");
        },
    }, //fin methods
    setup() {
        const {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        } = useList();

        return {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        };
    },
    computed: {
        totalRows() {
            return this.dataReport.length;
        },
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
